import { ScrollableList } from 'components/DesignSystems/ScrollableList';
import { MdLock, MdStar } from 'react-icons/md';
import { Channel } from 'types/channels';

interface TemplateReviewProps {
  description?: string;
  channels?: Channel[];
  label: string;
}

export default function TemplateReview({
  description,
  channels,
  label,
}: TemplateReviewProps) {
  return (
    <div className="p-4 pt-3 border border-neutral-700 rounded">
      <p className="fs-3 mb-1 fw-light">{label}</p>
      <p className="text-muted">{description}</p>

      <p className="fw-semibold text-uppercase tracking-tighter small mb-2 text-muted">
        Channels ({channels?.length || 0})
      </p>

      <ScrollableList
        emptyMessage="No channels configured"
        viewportHeightPercentage={40}
      >
        {channels?.map((channel) => (
          <div
            key={channel.displayName}
            className="bg-neutral-800 rounded p-3 mb-2 d-flex justify-content-between"
          >
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center">
                <p className="m-0 me-1">{channel.displayName}</p>
                {channel.membershipType === 'private' && (
                  <span className="text-muted">
                    <MdLock size={18} />
                  </span>
                )}
                {channel.isFavoriteByDefault && (
                  <span className="text-muted">
                    <MdStar size={18} />
                  </span>
                )}
              </div>
              {channel.description && (
                <p className="text-muted small mt-1 mb-0">
                  {channel.description}
                </p>
              )}
            </div>
            <div className="d-flex align-items-center gap-2 text-muted small ms-3">
              <span>
                {channel.isFavoriteByDefault
                  ? 'Is Favorite by Default /'
                  : null}
              </span>
              <span>
                {channel.membershipType === 'private'
                  ? 'Private'
                  : 'Shown by Default'}
              </span>
            </div>
          </div>
        ))}
      </ScrollableList>
    </div>
  );
}
